// extracted by mini-css-extract-plugin
export default {"container":"startForm_container__4SHNX","tagId":"startForm_tagId__14a4y"};